import React from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import useChart from '../../hooks/useChart';

Highcharts.setOptions({
  global: {
    useUTC: false,
  },
});

const OGHighchart = ({ series, config = {}, onAllClick }) => {
  const chartOptions = useChart(series, config, onAllClick);

  return (
    <HighchartsReact
      highcharts={Highcharts}
      constructorType={'stockChart'}
      options={chartOptions}
    />
  );
};

export default OGHighchart;
